/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import React from 'react'
import { OrgScheduleContextProvider } from 'src/context/OrgScheduleContext'
import OrgScheduleFilterBar from './OrgScheduleFilterBar'
import OrgScheduleList from './OrgScheduleList'

interface OrgScheduleProps {
  orgId: string
  setVisibleGameIds?: (
    valueOrFn: string[] | ((prev: string[]) => string[])
  ) => void
}

/**
 * OrgSchedule component
 * Main component for the organization schedule tab
 * Displays games with filtering capabilities
 */
const OrgSchedule: React.FC<OrgScheduleProps> = ({
  orgId,
  setVisibleGameIds,
}) => {
  return (
    <OrgScheduleContextProvider orgId={orgId}>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          min-height: 100%;
          gap: 24px;
          @media (max-width: 768px) {
            padding: 16px;
            gap: 16px;
          }
        `}
      >
        <OrgScheduleFilterBar />
        <OrgScheduleList setVisibleGameIds={setVisibleGameIds} />
      </div>
    </OrgScheduleContextProvider>
  )
}

export default OrgSchedule
